import { useEffect, useState } from "react";

const useTimer = (targetTime: number | null) => {
  const [timeLeft, setTimeLeft] = useState<number>(0);
  const [finished, setFinished] = useState(false);

  useEffect(() => {
    if (!targetTime) return;

    const update = () => {
      const remaining = Math.max(0, targetTime - Date.now());
      setTimeLeft(remaining);

      if (remaining === 0) {
        setFinished(true);
      }
    };

    update();

    const interval = setInterval(update, 1000);

    return () => clearInterval(interval);
  }, [targetTime]);

  return { timeLeft, finished };
};

export default useTimer;
